import axios from "axios";
//import authHeader from "./auth-header";

const API_URL = "https://unity-backend.herokuapp.com/api/v1/";

const getUsers = () => {
    return axios.get(API_URL + "users");
};

const getMessages = () => {
    return axios.get(API_URL + "posts");
}

export default {
    getUsers,
    getMessages
};